import React, { useEffect, useState } from "react";
import DocEditor from '../../components/ContractTemplate/DocEditor'
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";

const DocumentTemplate = () => {
  const [data, setData] = useState({})
  
  const getData = async () => {
    let res = await get(`${URLS.CONTRACT_TEMPLATE_VIEW}?type=1`)
    if (res?.status === 'success') {
      setData(res?.data)
    }
  }

  const updateDocument = async (d) => {
    let payload = {
      type: 1,
      document_template:d?.html
    }
    if(data?.id) payload['id'] = data?.id
    console.log("update document", d, payload)
    let res = await post(URLS.CONTRACT_TEMPLATE, payload)
    if (res?.status === 'success') {
      toast.success(res?.message)
      setData(res?.data)
    }
  }

  useEffect(() => {
    getData();
  }, []);

  return (
    <div style={{height:'100vh'}}>
      <DocEditor onSave={updateDocument} initialHtml={data?.template ?? ""} />
    </div>
  )
  
};

export default DocumentTemplate;
